/** Legacy / DB default: Follow Site Schedule is ON when creating a unit (AC1/AC2). */
export const UNIT_CREATE_FOLLOW_PARENT_SCHEDULE_DEFAULT = true

/** Shared Follow Site default for Units → New Batch (AC2). */
export const UNIT_BATCH_FOLLOW_PARENT_SCHEDULE_DEFAULT = true

/** Create form: omit/null → legacy ON; explicit false/true preserved (edit). */
export const resolveUnitCreateFollowParentSchedule = (
  initialFollowParentSchedule: boolean | null | undefined,
): boolean => initialFollowParentSchedule ?? UNIT_CREATE_FOLLOW_PARENT_SCHEDULE_DEFAULT

// Keys match what deep_camelize_keys produces from the snake_case JSONB column names
export const ACCREDITATION_FIELDS = [
  { key: 'jointCommission', label: 'Joint Commission' },
  { key: 'accCap', label: 'CAP' },
  { key: 'accCola', label: 'COLA' },
  { key: 'accAabb', label: 'AABB' },
  { key: 'accAala', label: 'AALA' },
  { key: 'accAoa', label: 'AOA/HFAP' },
  { key: 'accAshi', label: 'ASHI' },
  { key: 'accNydoh', label: 'NYDOH' },
  { key: 'accCadoh', label: 'CADOH' },
  { key: 'accFldoh', label: 'FLDOH' },
  { key: 'accNyspfi', label: 'NYSPFI' },
  { key: 'accFda', label: 'FDA' },
  { key: 'auId', label: 'AU-ID' },
] as const
